
// Keycode reference

var KEY = {
  BACKSPACE: 8,
  LEFT: 37,
  RIGHT: 39,
};


//
// Credit Card Expiry Input
//
// Maturalistic input of CC expiry date through masking.
//

module.exports = function CCExpiry ($host, config) {

  var dom = {
    main:  $host,
    mm: $('[data-cc-month]', $host),
    yy: $('[data-cc-year]',  $host)
  };


  // State

  var state = {
    monthLengthAtKeydown: dom.mm.val().length
  }


  // Functions

  function monthKeydown (event) {
    var rightmost = dom.mm[0].selectionStart === state.monthLengthAtKeydown;
    state.monthLengthAtKeydown = dom.mm.val().length;

    // Move caret across if in rightmost position
    if (event.which === KEY.RIGHT && rightmost) { dom.yy.focus(); event.preventDefault(); }
  }

  function monthKeyup (event) {
    var changed = dom.mm.val().length !== state.monthLengthAtKeydown;

    // If month was just now completed, focus year input
    if (changed && dom.mm.val().length === 2) { dom.yy.focus(); }
  }

  function yearKeydown (event) {
    var leftmost = dom.yy[0].selectionEnd === 0;
    state.monthLengthAtKeydown = dom.mm.val().length;

    // Allow deleting all the way back into month
    if (event.which === KEY.BACKSPACE && leftmost) { dom.mm.focus(); }

    // Move caret across if in leftmost position
    if (event.which === KEY.LEFT && leftmost) { dom.mm.focus(); event.preventDefault(); }
  }


  // Listeners

  dom.mm.on({ keydown: monthKeydown, keyup:monthKeyup });
  dom.yy.on({ keydown: yearKeydown });

}

